import {FC} from 'react';

type Icon = {
    className?: string;
};

const Statistic: FC<Icon> = ({className}) => (
    <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            d="M17.8 18.8a1 1 0 1 0 0-2v2ZM2 1a1 1 0 0 0-2 0h2Zm2.423 16.117.454-.891-.454.89Zm-2.74-2.74-.89.454.89-.454ZM4.3 9.886a1 1 0 0 0 1.4 1.428L4.3 9.886Zm5.13-3.629.702-.713a1 1 0 0 0-1.401-.001l.7.714Zm3.14 3.086-.702.713a1 1 0 0 0 1.402 0l-.7-.713ZM17.8 4.2h1a1 1 0 0 0-1-1v1Zm-1 3.086a1 1 0 1 0 2 0h-2ZM14.661 3.2a1 1 0 0 0 0 2v-2ZM17.8 16.8h-6.769v2H17.8v-2ZM2 7.769V1H0v6.769h2Zm9.031 9.031c-1.772 0-3.041 0-4.036-.082-.984-.08-1.612-.235-2.118-.492l-.908 1.782c.835.425 1.756.613 2.863.703 1.095.09 2.46.089 4.199.089v-2ZM0 7.769c0 1.74 0 3.104.089 4.2.09 1.106.278 2.027.703 2.862l1.782-.908c-.258-.506-.412-1.134-.492-2.118C2.001 10.81 2 9.541 2 7.77H0Zm4.877 8.457a5.27 5.27 0 0 1-2.303-2.303l-1.782.908a7.27 7.27 0 0 0 3.177 3.177l.908-1.782Zm.823-4.912 4.43-4.343-1.4-1.428L4.3 9.886l1.4 1.428ZM8.73 6.97l3.138 3.086L13.27 8.63l-3.138-3.086L8.73 6.97Zm4.54 3.086 5.231-5.143L17.1 3.487l-5.23 5.143 1.401 1.426ZM16.8 4.2v3.086h2V4.2h-2Zm1-1h-3.139v2H17.8v-2Z"
            fill="#F4F6FC"
        />
    </svg>
);

export default Statistic;
